import React, { useState, useEffect } from 'react';
import api from '../api';

import TableEditor from './TableEditor';
import './CreateProjectForm.css';

const CreateProjectForm = ({ onProjectCreated }) => {
    const [currentStep, setCurrentStep] = useState('description');
    const [stepNumber, setStepNumber] = useState(1);
    const [newProject, setNewProject] = useState(null);
    const [isCreatingEmptyProject, setIsCreatingEmptyProject] = useState(false);

    const [pages, setPages] = useState(2);



    // State to store project data
    const [projectData, setProjectData] = useState({
        description: '',
        language: 'english',
        tone: 'Informative',
        length: pages
    });

    const MAX_CHARACTERS = 5000; // Limite de caractères augmentée à 5000

    useEffect(() => {
        if (newProject) {
            setStepNumber(5); // Mettre à jour l'état en dehors du JSX
        }

        const desc = localStorage.getItem("currentDescription");
        if (desc) {
            setProjectData({ ...projectData, ['description']: desc });
        }

    }, [newProject]);

    // Handle step change
    const nextStep = (stepNumber) => {
        setCurrentStep(stepsName[stepNumber]);
        setStepNumber(stepNumber);
    };

    const handleSliderChange = (event) => {
        setPages(event.target.value);
        setProjectData({ ...projectData, ['length']: event.target.value });
    };

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setProjectData({ ...projectData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        nextStep(5);

        // Use project data for the API request
        api.post('/create_project', {
            description: projectData.description,
            language: projectData.language,
            tone: projectData.tone,
            length: projectData.length
        })
            .then(response => {
                const newProject = response.data;
                setNewProject(newProject);
            })
            .catch(error => console.error(error));
    };

    // Fonction pour créer un projet vide
    const createEmptyProject = () => {
        setIsCreatingEmptyProject(true);
        
        api.post('/create_empty_project', {
            language: projectData.language,
            tone: projectData.tone
        })
        .then(response => {
            console.log("Empty project created successfully:", response.data);
            // Rediriger directement vers l'éditeur sans passer par les étapes intermédiaires
            if (response.data && response.data.project_id) {
                onProjectCreated(response.data.project_id);
            } else {
                console.error("No project_id returned from server");
                setIsCreatingEmptyProject(false);
            }
        })
        .catch(error => {
            console.error('Error creating empty project:', error);
            setIsCreatingEmptyProject(false);
        });
    };

    // Handle project validation in TableEditor
    const handleProjectValidation = (projectId) => {
        onProjectCreated(projectId);
    };

    // List of languages with flags and lowercased names
    const languages = [
        { name: 'afrikaans', flag: '🇿🇦' },
        { name: 'arabic', flag: '🇸🇦' },
        { name: 'bengali', flag: '🇧🇩' },
        { name: 'bulgarian', flag: '🇧🇬' },
        { name: 'chinese simplified', flag: '🇨🇳' },
        { name: 'chinese traditional', flag: '🇹🇼' },
        { name: 'croatian', flag: '🇭🇷' },
        { name: 'czech', flag: '🇨🇿' },
        { name: 'danish', flag: '🇩🇰' },
        { name: 'dutch', flag: '🇳🇱' },
        { name: 'english', flag: '🇬🇧' },
        { name: 'finnish', flag: '🇫🇮' },
        { name: 'french', flag: '🇫🇷' },
        { name: 'german', flag: '🇩🇪' },
        { name: 'greek', flag: '🇬🇷' },
        { name: 'hebrew', flag: '🇮🇱' },
        { name: 'hindi', flag: '🇮🇳' },
        { name: 'hungarian', flag: '🇭🇺' },
        { name: 'indonesian', flag: '🇮🇩' },
        { name: 'italian', flag: '🇮🇹' },
        { name: 'japanese', flag: '🇯🇵' },
        { name: 'korean', flag: '🇰🇷' },
        { name: 'malay', flag: '🇲🇾' },
        { name: 'marathi', flag: '🇮🇳' },
        { name: 'norwegian', flag: '🇳🇴' },
        { name: 'persian', flag: '🇮🇷' },
        { name: 'polish', flag: '🇵🇱' },
        { name: 'portuguese', flag: '🇵🇹' },
        { name: 'portuguese brazilian', flag: '🇧🇷' },
        { name: 'romanian', flag: '🇷🇴' },
        { name: 'russian', flag: '🇷🇺' },
        { name: 'serbian', flag: '🇷🇸' },
        { name: 'slovak', flag: '🇸🇰' },
        { name: 'slovenian', flag: '🇸🇮' },
        { name: 'spanish', flag: '🇪🇸' },
        { name: 'swahili', flag: '🇰🇪' },
        { name: 'swedish', flag: '🇸🇪' },
        { name: 'tagalog', flag: '🇵🇭' },
        { name: 'tamil', flag: '🇮🇳' },
        { name: 'telugu', flag: '🇮🇳' },
        { name: 'thai', flag: '🇹🇭' },
        { name: 'turkish', flag: '🇹🇷' },
        { name: 'ukrainian', flag: '🇺🇦' },
        { name: 'urdu', flag: '🇵🇰' },
        { name: 'vietnamese', flag: '🇻🇳' }
    ];

    const lengthEnum = {
        1: "short",
        2: "medium",
        3: "long",
        4: "very_long",
    }

    const stepsName = {
        1: "description",
        2: "language",
        3: "length",
        4: "tone",
        5: "toc"
    }

    const stepsTitle = {
        1: "What do you want us to write about?",
        2: "Which language do you want us to write in?",
        3: "How long should it be?",
        4: "How should it sound? Pick your tone of voice",
        5: "Review & edit your table of contents",
    };


    return (
        <div className='create-project-container'>




            {newProject ? (
                // If the project is created, show the table editor
                <TableEditor project={newProject} onProjectValidation={handleProjectValidation} />
            ) : (
                <>
                    <h1>{stepsTitle[stepNumber]}</h1>
                    <div class="step-container">
                        <div class={stepNumber == 1 ? "step active" : "step"}>
                            <span class="step-number">1</span>
                        </div>
                        <div class={stepNumber == 2 ? "step active" : "step"}>
                            <span class="step-number">2</span>
                        </div>
                        <div class={stepNumber == 3 ? "step active" : "step"}>
                            <span class="step-number">3</span>
                        </div>
                        <div class={stepNumber == 4 ? "step active" : "step"}>
                            <span class="step-number">4</span>
                        </div>
                        <div class={stepNumber == 5 ? "step active" : "step"}>
                            <span class="step-number">5</span>
                        </div>
                        {/* <div class={stepNumber == 6 ? "step active" : "step"}>
                            <span class="step-number">6</span>
                        </div> */}
                    </div>

                    <div>



                        {/* Step for project description */}
                        {currentStep === 'description' && (
                            <div className="creation-step">
                                <textarea
                                    name="description"
                                    value={projectData.description}
                                    onChange={handleChange}
                                    placeholder="Enter project description / topic / subject"
                                    maxLength={MAX_CHARACTERS}
                                    required
                                />
                                <div 
                                    className={`char-counter ${
                                        projectData.description.length > MAX_CHARACTERS * 0.9 
                                            ? 'at-limit' 
                                            : projectData.description.length > MAX_CHARACTERS * 0.7 
                                                ? 'approaching-limit' 
                                                : ''
                                    }`}
                                >
                                    {projectData.description.length} / {MAX_CHARACTERS}
                                </div>
                            </div>
                        )}

                        {/* Step for selecting language */}
                        {currentStep === 'language' && (
                            <div className="creation-step">
                                <select
                                    name="language"
                                    value={projectData.language}
                                    onChange={handleChange}
                                    required
                                >
                                    {languages.map((lang) => (
                                        <option key={lang.name} value={lang.name} selected={lang.name === "english"}>
                                            {lang.name.charAt(0).toUpperCase() + lang.name.slice(1)} {lang.flag}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {currentStep === 'length' && (
                            <div className="creation-step">
                                <input
                                    type="range"
                                    min="1"
                                    max="6"
                                    value={pages}
                                    onChange={handleSliderChange}
                                    className="slider"
                                />
                                <p>Approx. {pages * 2 * 7200} - {pages * 2 * 7200 * 2} symbols / {pages * 2 * 1200} - {pages * 2 * 1200 * 2} words</p>


                            </div>
                        )}

                        {/* Step for selecting tone */}
                        {currentStep === 'tone' && (
                            <div className="creation-step">
                                <div className="tone-options">
                                    {['Formal', 'Informative', 'Objective', 'Analytical', 'Persuasive', 'Narrative', 'Descriptive', 'Casual'].map((tone) => (
                                        <button
                                            type="button"
                                            key={tone}
                                            className={`tone-option ${projectData.tone === tone ? 'selected' : ''}`}
                                            onClick={() => setProjectData({ ...projectData, tone })}
                                        >
                                            {tone}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}

                        {currentStep === "toc" && (

                            <svg xmlns="http://www.w3.org/2000/svg" height="200px" width="200px" viewBox="0 0 200 200" class="pencil">
                                <defs>
                                    <clipPath id="pencil-eraser">
                                        <rect height="30" width="30" ry="5" rx="5"></rect>
                                    </clipPath>
                                </defs>
                                <circle transform="rotate(-113,100,100)" stroke-linecap="round" stroke-dashoffset="439.82" stroke-dasharray="439.82 439.82" stroke-width="2" stroke="#157aff" fill="none" r="70" class="pencil__stroke"></circle>
                                <g transform="translate(100,100)" class="pencil__rotate">
                                    <g fill="none">
                                        <circle transform="rotate(-90)" stroke-dashoffset="402" stroke-dasharray="402.12 402.12" stroke-width="30" stroke="#157aff" r="64" class="pencil__body1"></circle>
                                        <circle transform="rotate(-90)" stroke-dashoffset="465" stroke-dasharray="464.96 464.96" stroke-width="10" stroke="#4694ff" r="74" class="pencil__body2"></circle>
                                        <circle transform="rotate(-90)" stroke-dashoffset="339" stroke-dasharray="339.29 339.29" stroke-width="10" stroke="#0061e6" r="54" class="pencil__body3"></circle>
                                    </g>
                                    <g transform="rotate(-90) translate(49,0)" class="pencil__eraser">
                                        <g class="pencil__eraser-skew">
                                            <rect height="30" width="30" ry="5" rx="5" fill="#78adff"></rect>
                                            <rect clip-path="url(#pencil-eraser)" height="30" width="5" fill="#4694ff"></rect>
                                            <rect height="20" width="30" fill="#e6f0ff"></rect>
                                            <rect height="20" width="15" fill="#b3d1ff"></rect>
                                            <rect height="20" width="5" fill="#cce0ff"></rect>
                                            <rect height="2" width="30" y="6" fill="hsla(217, 100%, 20%, 0.2)"></rect>
                                            <rect height="2" width="30" y="13" fill="hsla(217, 100%, 20%, 0.2)"></rect>
                                        </g>
                                    </g>
                                    <g transform="rotate(-90) translate(49,-30)" class="pencil__point">
                                        <polygon points="15 0,30 30,0 30" fill="#157aff"></polygon>
                                        <polygon points="15 0,6 30,0 30" fill="#0061e6"></polygon>
                                        <polygon points="15 0,20 10,10 10" fill="#003075"></polygon>
                                    </g>
                                </g>
                            </svg>

                        )}
                    </div>
                </>
            )}

            <div className='navigation-buttons'>
                <div className="main-buttons">
                    {stepNumber > 1 && stepNumber < 5 && (
                        <button className="button-hollow" onClick={() => nextStep(stepNumber - 1)}>
                            <span className="material-symbols-outlined">arrow_back_ios</span>
                            Back
                        </button>
                    )}

                    {stepNumber < 4 && (
                        <button className="button-plain" onClick={() => nextStep(stepNumber + 1)} disabled={!projectData.description.trim()}>
                            Next
                            <span className="material-symbols-outlined">arrow_forward_ios</span>
                        </button>
                    )}

                    {stepNumber == 4 && (
                        <button className="button-plain" onClick={handleSubmit}>
                            Create table of content
                            <span className="material-symbols-outlined">arrow_forward_ios</span>
                        </button>
                    )}
                </div>

                {currentStep === 'description' && (
                    <button 
                        className="button-hollow empty-project-button" 
                        onClick={createEmptyProject}
                        disabled={isCreatingEmptyProject}
                    >
                        {isCreatingEmptyProject ? (
                            <>
                                <span className="loader-small"></span>
                                Creating...
                            </>
                        ) : (
                            <>
                                <span className="material-symbols-outlined">note_add</span>
                                Create Empty Project
                            </>
                        )}
                    </button>
                )}
            </div>

        </div>

    );
};

export default CreateProjectForm;
